import styled from "styled-components";
import { Label4 } from "../../../kanopy-ui/Texts/Texts";

export const NoteStyled = styled(Label4)`
   font-size: 14px;
   padding-left: 20px;
   padding-top: 15px;
   padding-bottom: 15px;
`;
